import { render, staticRenderFns } from "./TheView.vue?vue&type=template&id=4c07cadd&scoped=true&"
import script from "./TheView.vue?vue&type=script&lang=ts&"
export * from "./TheView.vue?vue&type=script&lang=ts&"
import style0 from "./TheView.vue?vue&type=style&index=0&id=4c07cadd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07cadd",
  null
  
)

export default component.exports